// import React, { useEffect, useState, useContext } from 'react';
// import { Row, Col, Table, Image, Modal, Button, Switch, message } from 'antd';
// import axios from 'axios';
// import { GlobalContext } from "../../../lib/context";

// interface Subscription {
//     plan_name: string;
//     plan_code: string;
//     last_update_date: string;
// }

// interface PlanUsageState {
//     [key: string]: {
//         plan_name: string;
//         plan_code: string;
//         total_licenses: number;
//         licenses_available: number;
//         licenses_used: number;
//     };
// }

// interface User {
//     full_name: string;
//     user_status: string;
//     user_email: string;
//     creation_date: string;
//     last_update_date: string;
//     image_name: string;
//     user_id: number;
// }

// interface UserProfileProps {
//     visible: boolean;
//     userId: number;
//     onClose: () => void;
// }

// const UserSubscriptionDetails: React.FC<UserProfileProps> = ({ visible, userId, onClose }) => {
//     const [user, setUser] = useState<User | null>(null);
//     const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
//     const [planUsageState, setPlanUsageState] = useState<PlanUsageState>({});
//     const [currentPlanNameArr, setCurrentPlanNameArr] = useState<string[]>([]);
//     const [planNameArr, setPlanNameArr] = useState<string[]>([]);
//     const [loading, setLoading] = useState(true);
//     const [hasChanges, setHasChanges] = useState(false);
//     const [modalReady, setModalReady] = useState(false);
//     const { profile, setProfile } = useContext(GlobalContext);
//     const image_path = `${process.env.REACT_APP_BASE_URL || ""}` + "/images/default_face.png";
//     const token = localStorage.getItem('cxspsa') || '';
//     const baseURL = `${process.env.REACT_APP_BACKEND_URL || ""}api/`;
//     const imageBaseURL = `${process.env.REACT_APP_IMAGE_URL || ""}`;
//     const getFileNameFromPath = (imagePath: string) => {
//         return imagePath ? imagePath.split('/').pop() || "" : "";
//       };
//       const [action, setAction] = useState<string>(""); // Holds "Add" or "Remove"
//       const fetchUserData = async () => {
//         try {
//             setLoading(true);
//             const response = await axios.get(baseURL+`get_user_subscription_data/${userId}`, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`,
//                 },
//             });
            
//             setUser(response.data.user);
//             setSubscriptions(response.data.subscriptions || []);
//             setPlanUsageState(response.data.planUsageState || {});
//             setCurrentPlanNameArr(response.data.currentPlanNameArr || []);
//             setPlanNameArr(response.data.currentPlanNameArr || []);
//             setModalReady(true);
//         } catch (err) {
//             console.error('Error fetching user data:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (visible && userId) {
//             fetchUserData();
//         }
//     }, [visible, userId]);

//     useEffect(() => {
//         if (!visible) {
//             setUser(null);
//             setSubscriptions([]);
//             setPlanUsageState({});
//             setCurrentPlanNameArr([]);
//             setHasChanges(false);
//             setModalReady(false);
//         }
//     }, [visible]);

//     const handleOk = async () => {
//         if (!hasChanges) return;
        
//         setLoading(true);
//         const formDataToSend = new FormData();
//         formDataToSend.append('userId', userId.toString());
//         formDataToSend.append("currentPlanNames", JSON.stringify(currentPlanNameArr));
//         if(action == "Add") {
//             try {
//                 const response = await fetch(baseURL+'set_user_subscription_data', {
//                     method: 'POST',
//                     headers: {
//                         'Authorization': `Bearer ${token}`,
//                     },
//                     body: formDataToSend,
//                 });
    
//                 if (response.ok) {
//                     message.success("License Added to User Successfully")
//                     onClose();
//                 } else {
//                     message.error("Failed to Add License to User")
//                     console.error('Failed to save the data.');
//                 }
//             } catch (error) {
//                 console.error('Error while saving the data:', error);
//             } finally {
//                 setLoading(false);
//             }

//         } else {
//             try {
//                 const response = await fetch(baseURL+'delete_user_subscription_data', {
//                     method: 'POST',
//                     headers: {
//                         'Authorization': `Bearer ${token}`,
//                     },
//                     body: formDataToSend,
//                 });
    
//                 if (response.ok) {
//                     message.success("License successfully removed from user")
//                     onClose();
//                 } else {
//                     message.error("Failed to Add License to User")
//                     console.error('Failed to save the data.');
//                 }
//             } catch (error) {
//                 console.error('Error while saving the data:', error);
//             } finally {
//                 setLoading(false);
//             }

//         }
//     };
    

//     const handleSwitchChange = (checked: boolean, record: any, action: string) => {
//         const currentPlan = `${record.plan_name} ## ${record.plan_code}`;
//         console.log(currentPlan)
//         let updatedPlans: string[];
        
//         if (checked) {
//             if(action == "Add") {
//                 setAction("Add")
//             } else{
//                 setAction("Remove")
//             }
//             updatedPlans = [...currentPlanNameArr, currentPlan];
//               // If the array is empty or the first item doesn't follow the format, 
//         // ensure all items have the correct format
//         // if (currentPlanNameArr.length === 0 || !currentPlanNameArr[0].includes('##')) {
//         //     const formattedCurrentPlan = `${record.plan_name} ## ${record.plan_code}`;
//         //     updatedPlans = [formattedCurrentPlan, currentPlan];
//         // } else {
//         //     updatedPlans = [...currentPlanNameArr, currentPlan];
//         // }
//         } else {
//             updatedPlans = currentPlanNameArr.filter(plan => plan !== currentPlan);
//         }
//         console.log(updatedPlans)
//         setCurrentPlanNameArr(updatedPlans);
//         setHasChanges(true);
//     };

//     const columnsCurrentSubscription = [
//         { title: 'Plan Name', dataIndex: 'plan_name', key: 'plan_name' },
//         { title: 'Plan Code', dataIndex: 'plan_code', key: 'plan_code' },
//         { 
//             title: 'Subscribed Date', 
//             dataIndex: 'last_update_date', 
//             key: 'last_update_date',
//             render: (date: string) => new Date(date).toLocaleDateString() 
//         },
//         {
//             title: 'Remove License',
//             key: 'actions',
//             render: (text: string, record: Subscription) => (
//                 <Switch 
//                     checked={currentPlanNameArr.includes(`${record.plan_name} ## ${record.plan_code}`)}
//                     onChange={(checked) => handleSwitchChange(checked, record, "Remove")}
//                 />
//             ),
//             // render: (text: string, record: any) => (
//             //     // record.licenses_available > 0 && (
//             //       <a
//             //         href="#"
//             //         onClick={(e) => {
//             //           e.preventDefault();
//             //           handleSwitchChange(!currentPlanNameArr.includes(`${record.plan_name} ## ${record.plan_code}`), record);
//             //         }}
//             //         style={{
//             //           color: '#1677ff',
//             //           textDecoration: 'none',
//             //           cursor: 'pointer'
//             //         }}
//             //       >
//             //         {currentPlanNameArr.includes(`${record.plan_name} ## ${record.plan_code}`) ? 'Remove License' : 'Add License'}
//             //       </a>
//             //     )
//             //   ),
          
//         },
//     ];

//     const columnsAvailablePlans = [
//         { title: 'Plan Name', dataIndex: 'plan_name', key: 'plan_name' },
//         { title: 'Plan Code', dataIndex: 'plan_code', key: 'plan_code' },
//         { title: 'Licenses Available', dataIndex: 'licenses_available', key: 'licenses_available' },
//         { title: 'Licenses Used', dataIndex: 'licenses_used', key: 'licenses_used' },
//         {
//             title: 'Add License',
//             key: 'actions',
//             render: (text: string, record: any) => (
//                 record.licenses_available > 0 && (
//                     <Switch 
//                         checked={currentPlanNameArr.includes(`${record.plan_name} ## ${record.plan_code}`)}
//                         onChange={(checked) => handleSwitchChange(checked, record, "Add")}
//                     />
//                 )
//             ),
//         },
//     ];

//     const availablePlansData = Object.keys(planUsageState)
//         .map(plan => ({
//             ...planUsageState[plan]
//         }));

//     if (!modalReady) {
//         return (
//             <Modal
//                 open={visible}
//                 title="License Details"
//                 onCancel={onClose}
//                 footer={null}
//             >
//                 <div className="flex items-center justify-center p-4">
//                     <p>Loading License details...</p>
//                 </div>
//             </Modal>
//         );
//     }

//     return (
//         <Modal
//             open={visible}
//             title="License Details"
//             onCancel={onClose}
//             footer={[
//                 <Button key="cancel" onClick={onClose}>
//                     Cancel
//                 </Button>,
//                 <Button 
//                     key="submit" 
//                     type="primary" 
//                     onClick={handleOk}
//                     disabled={!hasChanges || loading}
//                 >
//                     {loading ? 'Saving...' : 'Confirm'}
//                 </Button>,
//             ]}
//             width={800}
//         >
//             <div className="container">
//                 <Row gutter={16} className="mt-2">
//                     <Col span={4}>
//                         <Image
//                             width={120}
//                             src={user?.image_name ? imageBaseURL + getFileNameFromPath(user.image_name) : image_path}
//                         />
//                     </Col>
//                     <Col span={20}>
//                         <h4>{user?.full_name} <small>({user?.user_status})</small></h4>
//                         <p>{user?.user_email}</p>
//                         <p>Created Date: {user?.creation_date && new Date(user.creation_date).toLocaleDateString()}</p>
//                         <p>Plan Last Updated Date: {user?.last_update_date && new Date(user.last_update_date).toLocaleDateString()}</p>
//                     </Col>
//                 </Row>

//                 {/* <Row className="mt-4" style={{marginTop:'20px'}}>
//                     {profile.is_trial === false ? (
//                         <Col span={24}>
//                             <h4>Current Subscription</h4>
//                             <Table 
//                                 columns={columnsCurrentSubscription} 
//                                 dataSource={subscriptions} 
//                                 rowKey="plan_name" 
//                             />
//                         </Col>
//                      ):( <p>You are in a trial period, click the Upgrade button to purchase a license</p>)}
//                 </Row> */}
//                 {/* <Row className="mt-4" style={{ marginTop: '20px' }}>
//                     {profile.is_trial === true ? (
//                         // Display trial message when the user is in a trial period
//                         <p>You are in a trial period, click the Upgrade button to purchase a license</p>
//                     ) : (
//                         // Display Current Subscription only if currentPlanNameArr is not empty
//                         currentPlanNameArr.length > 0 ? (
//                             <Col span={24}>
//                                 <h4>Current Subscription</h4>
//                                 <Table 
//                                     columns={columnsCurrentSubscription} 
//                                     dataSource={subscriptions} 
//                                     rowKey="plan_name" 
//                                 />
//                             </Col>
//                         ) : (
//                             // Fallback message for non-trial users with no subscriptions
//                             <p>No current subscriptions available.</p>
//                         )
//                     )}
//                 </Row>


//                 <Row className="mt-4">
//                     <Col span={24}>
//                         <h4>Additional Available Plans</h4>
//                         <Table 
//                             columns={columnsAvailablePlans} 
//                             dataSource={availablePlansData} 
//                             rowKey="plan_name" 
//                         />
//                     </Col>
//                 </Row> */}

//                 <div className="container">
//                     {/* Current Subscription Section */}
//                     <Row className="mt-4" style={{ marginTop: '20px' }}>
//                         {profile.is_trial === true ? (
//                             <p>You are in a trial period, click the Upgrade button to purchase a license</p>
//                         ) : planNameArr.length > 0 && (
//                             <Col span={24}>
//                                 <h4>Current Subscription</h4>
//                                 <Table 
//                                     columns={columnsCurrentSubscription} 
//                                     dataSource={subscriptions} 
//                                     rowKey="plan_name" 
//                                 />
//                             </Col>
//                         )}
//                     </Row>

//                     {/* Additional Available Plans Section */}
//                     <Row className="mt-4"  style={{ marginTop: '20px' }}>
//                         {planNameArr.length === 0 && (
//                             <Col span={24}>
//                                 <h4>Additional Available Plans</h4>
//                                 <Table 
//                                     columns={columnsAvailablePlans} 
//                                     dataSource={availablePlansData} 
//                                     rowKey="plan_name" 
//                                 />
//                             </Col>
//                         )}
//                     </Row>
//                 </div>

//             </div>
//         </Modal>
//     );
// };

// export default UserSubscriptionDetails;

import React, { useEffect, useState, useContext } from 'react';
import { Row, Col, Table, Image, Modal, Button, Switch, message } from 'antd';
import axios from 'axios';
import { GlobalContext } from "../../../lib/context";

interface Subscription {
    plan_name: string;
    plan_code: string;
    last_update_date: string;
}

interface PlanUsageState {
    [key: string]: {
        plan_name: string;
        plan_code: string;
        total_licenses: number;
        licenses_available: number;
        licenses_used: number;
    };
}

interface User {
    full_name: string;
    user_status: string;
    user_email: string;
    creation_date: string;
    last_update_date: string;
    image_name: string;
    user_id: number;
}

interface UserProfileProps {
    visible: boolean;
    userId: number;
    onClose: () => void;
}

const UserSubscriptionDetails: React.FC<UserProfileProps> = ({ visible, userId, onClose }) => {
    const [user, setUser] = useState<User | null>(null);
    const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
    const [planUsageState, setPlanUsageState] = useState<PlanUsageState>({});
    const [currentPlanNameArr, setCurrentPlanNameArr] = useState<string[]>([]);
    const [planNameArr, setPlanNameArr] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);
    const [hasChanges, setHasChanges] = useState(false);
    const [modalReady, setModalReady] = useState(false);
    const [action, setAction] = useState<string>("");
    const { profile } = useContext(GlobalContext);

    const image_path = `${process.env.REACT_APP_BASE_URL || ""}` + "/images/default_face.png";
    const token = localStorage.getItem('cxspsa') || '';
    const baseURL = `${process.env.REACT_APP_BACKEND_URL || ""}api/`;
    const imageBaseURL = `${process.env.REACT_APP_IMAGE_URL || ""}`;

    const getFileNameFromPath = (imagePath: string) => {
        return imagePath ? imagePath.split('/').pop() || "" : "";
    };

    const fetchUserData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(baseURL+`get_user_subscription_data/${userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            
            setUser(response.data.user);
            setSubscriptions(response.data.subscriptions || []);
            setPlanUsageState(response.data.planUsageState || {});
            setCurrentPlanNameArr(response.data.currentPlanNameArr || []);
            setPlanNameArr(response.data.currentPlanNameArr || []);
            setModalReady(true);
        } catch (err) {
            console.error('Error fetching user data:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (visible && userId) {
            fetchUserData();
        }
    }, [visible, userId]);

    useEffect(() => {
        if (!visible) {
            resetState();
        }
    }, [visible]);

    const resetState = () => {
        setUser(null);
        setSubscriptions([]);
        setPlanUsageState({});
        setCurrentPlanNameArr([]);
        setHasChanges(false);
        setModalReady(false);
        setAction("");
    };

    const handleOk = async () => {
        if (!hasChanges) return;
        
        setLoading(true);
        const formDataToSend = new FormData();
        formDataToSend.append('userId', userId.toString());
        formDataToSend.append("currentPlanNames", JSON.stringify(currentPlanNameArr));

        try {
            const endpoint = action === "Add" ? 'set_user_subscription_data' : 'delete_user_subscription_data';
            const response = await fetch(baseURL + endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formDataToSend,
            });

            if (response.ok) {
                message.success(action === "Add" ? 
                    "License Added to User Successfully" : 
                    "License successfully removed from user"
                );
                onClose();
            } else {
                message.error(action === "Add" ? 
                    "Failed to Add License to User" : 
                    "Failed to Remove License from User"
                );
            }
        } catch (error) {
            console.error('Error while saving the data:', error);
            message.error("An error occurred while processing your request");
        } finally {
            setLoading(false);
        }
    };

    const handleSwitchChange = (checked: boolean, record: any, actionType: string) => {
        const currentPlan = `${record.plan_name} ## ${record.plan_code}`;
        
        if (checked && currentPlanNameArr.length > 0 && actionType === "Add") {
            message.warning("Please remove the existing license before adding a new one");
            return;
        }

        setAction(actionType);
        const updatedPlans = checked 
            ? [...currentPlanNameArr, currentPlan]
            : currentPlanNameArr.filter(plan => plan !== currentPlan);

        setCurrentPlanNameArr(updatedPlans);
        setHasChanges(true);
    };

    const isSwitchDisabled = (record: any, actionType: string): boolean => {
        const currentPlan = `${record.plan_name} ## ${record.plan_code}`;
        const isCurrentPlan = currentPlanNameArr.includes(currentPlan);
        
        if (actionType === "Add") {
            // Disable if there's any plan selected other than this one
            return currentPlanNameArr.length > 0 && !isCurrentPlan;
        } else {
            // For "Remove" action, disable if this isn't the selected plan
            return currentPlanNameArr.length > 0 && !isCurrentPlan;
        }
    };

    const columnsCurrentSubscription = [
        { title: 'Plan Name', dataIndex: 'plan_name', key: 'plan_name' },
        { title: 'Plan Code', dataIndex: 'plan_code', key: 'plan_code' },
        { 
            title: 'Subscribed Date', 
            dataIndex: 'last_update_date', 
            key: 'last_update_date',
            render: (date: string) => new Date(date).toLocaleDateString() 
        },
        {
            title: 'Remove License',
            key: 'actions',
            render: (text: string, record: Subscription) => (
                <Switch 
                    checked={currentPlanNameArr.includes(`${record.plan_name} ## ${record.plan_code}`)}
                    onChange={(checked) => handleSwitchChange(checked, record, "Remove")}
                    // disabled={isSwitchDisabled(record, "Remove")}
                />
            ),
        },
    ];

    const columnsAvailablePlans = [
        { title: 'Plan Name', dataIndex: 'plan_name', key: 'plan_name' },
        { title: 'Plan Code', dataIndex: 'plan_code', key: 'plan_code' },
        { title: 'Licenses Available', dataIndex: 'licenses_available', key: 'licenses_available' },
        { title: 'Licenses Used', dataIndex: 'licenses_used', key: 'licenses_used' },
        {
            title: 'Add License',
            key: 'actions',
            render: (text: string, record: any) => (
                record.licenses_available > 0 && (
                    <Switch 
                        checked={currentPlanNameArr.includes(`${record.plan_name} ## ${record.plan_code}`)}
                        onChange={(checked) => handleSwitchChange(checked, record, "Add")}
                        disabled={isSwitchDisabled(record, "Add")}
                    />
                )
            ),
        },
    ];

    const availablePlansData = Object.keys(planUsageState)
        .map(plan => ({
            ...planUsageState[plan]
        }));

    if (!modalReady) {
        return (
            <Modal
                open={visible}
                title="License Details"
                onCancel={onClose}
                footer={null}
            >
                <div className="flex items-center justify-center p-4">
                    <p>Loading License details...</p>
                </div>
            </Modal>
        );
    }

    return (
        <Modal
            open={visible}
            title="License Details"
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button 
                    key="submit" 
                    type="primary" 
                    onClick={handleOk}
                    disabled={!hasChanges || loading}
                >
                    {loading ? 'Saving...' : 'Confirm'}
                </Button>,
            ]}
            width={800}
        >
            <div className="container">
                <Row gutter={16} className="mt-2">
                    <Col span={4}>
                        <Image
                            width={120}
                            src={user?.image_name ? imageBaseURL + getFileNameFromPath(user.image_name) : image_path}
                        />
                    </Col>
                    <Col span={20}>
                        <h4>{user?.full_name} <small>({user?.user_status})</small></h4>
                        <p>{user?.user_email}</p>
                        <p>Created Date: {user?.creation_date && new Date(user.creation_date).toLocaleDateString()}</p>
                        <p>Plan Last Updated Date: {user?.last_update_date && new Date(user.last_update_date).toLocaleDateString()}</p>
                    </Col>
                </Row>

                <div className="container">
                    <Row className="mt-4" style={{ marginTop: '20px' }}>
                        {profile.is_trial ? (
                            <p>You are in a trial period, click the Upgrade button to purchase a license</p>
                        ) : planNameArr.length > 0 && (
                            <Col span={24}>
                                <h4>Current Subscription</h4>
                                <Table 
                                    columns={columnsCurrentSubscription} 
                                    dataSource={subscriptions} 
                                    rowKey="plan_name" 
                                />
                            </Col>
                        )}
                    </Row>

                    <Row className="mt-4" style={{ marginTop: '20px' }}>
                        {planNameArr.length === 0 && (
                            <Col span={24}>
                                <h4>Additional Available Plans</h4>
                                <Table 
                                    columns={columnsAvailablePlans} 
                                    dataSource={availablePlansData} 
                                    rowKey="plan_name" 
                                />
                            </Col>
                        )}
                    </Row>
                </div>
            </div>
        </Modal>
    );
};

export default UserSubscriptionDetails;
